import { useEffect, useState } from "react";
import styles from "../TalentProfile.module.css";

const R = 36;
const C = 2 * Math.PI * R;

function fitLevel(pct) {
  if (pct >= 70) return { color: "#1d4ed8", label: "Strong match" };
  if (pct >= 45) return { color: "#d97706", label: "Good match" };
  return { color: "#ef4444", label: "Partial match" };
}

export function mapToCandidateFitData(talentDetails = {}) {
  const cvScore = Number(
    talentDetails?.aiInsights?.score ??
      talentDetails?.candidateFitScore ??
      talentDetails?.psychometricTestResult?.overallScore ??
      0,
  );
  const psychScore = Number(
    talentDetails?.psychometricTestResult?.logicScore ?? 0,
  );
  const blended = cvScore > 0 ? Math.round(cvScore * 0.7 + psychScore * 0.3) : psychScore;
  const pct = Math.max(0, Math.min(100, Math.round(blended)));
  return { pct };
}

const CandidateFitCard = ({ pct = 0 }) => {
  const [animatedPct, setAnimatedPct] = useState(0);
  const [offset, setOffset] = useState(C);
  const { color, label } = fitLevel(pct);

  useEffect(() => {
    const t = setTimeout(() => {
      setOffset(C - (pct / 100) * C);

      const dur = 900;
      let start = null;
      function tick(ts) {
        if (!start) start = ts;
        const prog = Math.min((ts - start) / dur, 1);
        setAnimatedPct(Math.round(prog * pct));
        if (prog < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }, 120);
    return () => clearTimeout(t);
  }, [pct]);

  return (
    <div className={`${styles.card} ${styles.cfitCard}`}>
      <div className={`${styles.cardBody} ${styles.cfitBody}`}>
        <div className={styles.cfitLabel}>CANDIDATE FIT</div>
        <div className={styles.cfitMain}>
          <div className={styles.cfitRingWrap}>
            <svg viewBox="0 0 88 88" xmlns="http://www.w3.org/2000/svg">
              <circle className={styles.cfitTrack} cx="44" cy="44" r={R} />
              <circle
                className={styles.cfitFill}
                cx="44"
                cy="44"
                r={R}
                stroke={color}
                strokeDasharray={C.toFixed(2)}
                strokeDashoffset={offset.toFixed(2)}
              />
            </svg>
            <div className={styles.cfitRingInner}>
              <div className={styles.cfitPct}>
                <span>{animatedPct}</span>
                <span className={styles.cfitPctSign}>%</span>
              </div>
            </div>
          </div>
          <div className={styles.cfitRight}>
            <div className={styles.cfitMatchLabel}>{label}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateFitCard;